<template>
  <div>
    <van-cell-group>
      <van-field v-model="courseDate" @click="isShowDate=true" readonly required label="上课日期:" label-width="70px" placeholder="请选择上课日期" />
      <van-field v-model="classSection" @click="classSectionClick" readonly required label="班级节次:" label-width="70px" placeholder="请选择班级节次" />
      <van-field v-model="subTeacher" @click="teacherClick" readonly required label="代课教师:" label-width="70px" placeholder="请选择代课教师" />
      <van-field v-model="option" rows="2" autosize label="代课原因:" label-width="70px" type="textarea" maxlength="20" placeholder="请输入代课原因" show-word-limit />
    </van-cell-group>

    <div class="approval-flow">
      <p class="flow-title">审批流程</p>
      <ul class="flow-ul">
        <li class="flow-li" v-for="(approval,apI) in approvalData" :key="apI" :style="{'display':(approval.CcMemberList.length===0&&approval.CCMemberData.length===0)?'flex':'block'}">
          <!-- 审批或者申请 -->
          <div class="flow-info" v-if="approval.NodeType===2">
            <em class="timeline-icon"></em>
            <div>
              <div style="color:#111111">{{approval.WorkFlowNodeName}}审批人</div>
              <p class="bottom-type" v-if="approval.AppMemberData.length>0">
                {{approval.AppMemberData.length}}人审批
              </p>
            </div>
            <ul class="user-ul">
              <!-- 审批人超过2人 -->
              <li class="user-li" v-if="approval.AppMemberData.length>2">
                <div class="user-name" @click="showMoreFun(approval.AppMemberData)">更多</div>
                <p class="bottom-type">更多</p>
                <!-- 更多 -->
                <van-popup v-model="showMore" position="bottom" :style="{height: '50%'}">
                  <div class="more-list">
                    <div v-for="(more,dIndex) in moreData" :key="dIndex">
                      <div class="user-li" v-if="dIndex>1">
                        <div class="user-del-icon" @click="delUser(more,true,apI)" v-if="approval.ApprovalMemberType!==0">
                          <van-icon name="clear" size="18" />
                        </div>
                        <div class="user-name" v-cloak>{{more.FullName.substring((more.FullName.length-2),more.FullName.length)}}</div>
                        <p class="bottom-type" v-cloak>{{more.FullName}}</p>
                      </div>
                    </div>
                  </div>
                </van-popup>
              </li>
              <!-- 审批人少于2人 -->
              <li v-for="(mItem,mIndex) in approval.AppMemberData" :key="mIndex">
                <div class="user-li" v-if="mIndex<2">
                  <div class="user-del-icon" @click="delUser(mItem,true,apI)" v-if="approval.ApprovalMemberType!==0">
                    <van-icon name="clear" size="18" />
                  </div>
                  <div class="user-name" v-cloak>{{mItem.FullName.substring((mItem.FullName.length-2),mItem.FullName.length)}}</div>
                  <p class="bottom-type" v-cloak>{{mItem.FullName}}</p>
                </div>
              </li>
              <li class="user-li" v-if="approval.ApprovalMemberType!==0">
                <div class="user-add" @click="addUserFun(approval,true)">+</div>
                <!-- 添加的审批人 -->
                <van-popup v-model="addUser" position="bottom" :style="{ height: '45%' }">
                  <van-cell-group>
                    <van-cell v-for="item in addUserData.ApprovalMemberList" :key="item.UserID" :value="item.FullName" @click="addAMUserFun(item)" class="class-section" />
                  </van-cell-group>
                </van-popup>
              </li>
            </ul>
          </div>
          <!-- 抄送 -->
          <div class="flow-info" v-if="approval.NodeType===1&&(approval.CcMemberList.length>0||approval.CCMemberData.length>0)">
            <em class="timeline-icon"></em>
            <div>
              <div style="color:#111111">抄送人</div>
              <p class="bottom-type" v-if="approval.CCMemberData.length>0" v-cloak>
                抄送{{approval.CCMemberData.length}}人
              </p>
            </div>
            <ul class="user-ul">
              <li class="user-li" v-if="approval.CCMemberData.length>2">
                <div class="user-name" @click="showMoreFun(approval.CCMemberData)">更多</div>
                <p class="bottom-type">更多</p>
                <!-- 更多 -->
                <van-popup v-model="showMore" position="bottom" :style="{height: '50%'}">
                  <div class="more-list">
                    <div v-for="(more,dIndex) in moreData" :key="dIndex">
                      <div class="user-li" v-if="dIndex>1">
                        <div class="user-del-icon" @click="delUser(more,false,apI)">
                          <van-icon name="clear" size="18" />
                        </div>
                        <div class="user-name" v-cloak>{{more.FullName.substring((more.FullName.length-2),more.FullName.length)}}</div>
                        <p class="bottom-type" v-cloak>{{more.FullName}}</p>
                      </div>
                    </div>
                  </div>
                </van-popup>
              </li>
              <li v-for="(mItem,mIndex) in approval.CCMemberData" :key="mIndex">
                <div class="user-li" v-if="mIndex<2">
                  <div class="user-del-icon" @click="delUser(mItem,false,apI)">
                    <van-icon name="clear" size="18" />
                  </div>
                  <div class="user-name" v-cloak>{{mItem.FullName.substring((mItem.FullName.length-2),mItem.FullName.length)}}</div>
                  <p class="bottom-type" v-cloak>{{mItem.FullName}}</p>
                </div>
              </li>
              <li class="user-li">
                <div class="user-add" @click="addUserFun(approval,false)">+</div>
                <!-- 添加的抄送人 -->
                <van-popup v-model="addCCUser" position="bottom" :style="{ height: '45%' }">
                  <van-cell-group>
                    <van-cell v-for="item in addCCUserData.CcMemberList" :key="item.UserID" :value="item.FullName" @click="addCCuserFun(item)" class="class-section" />
                  </van-cell-group>
                </van-popup>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>

    <div class="fotter-content">
      <van-button type="primary" class="sub-fix-btn" @click="submitFlow">保存</van-button>
    </div>

    <!-- 上课日期 -->
    <van-popup v-model="isShowDate" position="bottom" :style="{ height: '45%' }">
      <van-datetime-picker :min-date="minDate" @confirm="dateConfirm" @cancel="dateCancle" type="date">
      </van-datetime-picker>
    </van-popup>
    <!-- 班级节次 -->
    <van-popup v-model="isShowClassSection" position="bottom" :style="{ height: '45%' }">
      <van-cell-group>
        <van-cell v-for="item in district" :key="item.id" :value="item.label" @click="cellSelect(item)" class="class-section" />
      </van-cell-group>
    </van-popup>
    <!-- 班级节次 -->
    <van-popup v-model="showTeacher" position="bottom" :style="{ height: '45%' }">
      <van-tabs>
        <van-tab title="同年级同学科">
          <van-cell-group>
            <van-cell v-for="item in teacherData" :key="item.TeacherID" :value="item.TeacherName" @click="teacherSelect(item)" class="class-section" />
          </van-cell-group>
        </van-tab>
        <van-tab title="所有教师">
          <van-cell-group>
            <van-cell v-for="item in teacherAllData" :key="item.TeacherID" :value="item.TeacherName" @click="teacherSelect(item)" class="class-section" />
          </van-cell-group>
        </van-tab>
      </van-tabs>
    </van-popup>
  </div>
</template>

<script>
import xyapi from "@/common/api";
export default {
  components: {},
  data () {
    return {
      option: '',//原因
      //上课日期
      courseDate: '',
      minDate: new Date(),
      isShowDate: false,
      //班级节次
      district: [],
      classSection: '',
      classSectionID: 0,
      isShowClassSection: false,
      cellPostion: true,
      //代课教师
      subTeacher: '',
      subTeacherID: '',
      showTeacher: false,
      teacherData: [],
      teacherAllData: [],
      //审批流程
      approvalData: [],
      addUser: false,
      addUserData: [],
      showMore: false,
      moreData: [],
      addCCUserData: [],
      addCCUser: false,
    };
  },
  created: function () {
    console.log(this.$store.state.common.userInfo.UserID)

    this.getWorkFlowByType();
  },
  mounted: function () {

  },
  methods: {
    //上课日期
    dateConfirm (val) {
      this.courseDate = this.xy.moment(val).format("YYYY-MM-DD");
      this.isShowDate = false;
    },
    dateCancle () {
      this.isShowDate = false;
    },
    //根据审批流Type获取审批流条件
    async getWorkFlowByType () {
      this.xy.loading();
      // let res = await xyapi.get(`${this.$store.state.apiPath}/api/Comm/GetWorkFlowByType`,
      let res = await xyapi.post(`${this.$store.state.apiPublic}/api/WorkFlowSetting/ApprovalProcessByCondition`,
        {
          ApplicantUserID: this.$store.state.common.userInfo.UserID, //谁发起的代课，就传谁的id
          OrganizationID: 0,
          WorkFlowType: 2, // 调代课
          ConditionValues: []//只有1个分支：null，多个分支传数组，暂定为1个分支
        }
      );
      this.xy.unloading();
      if (res.success) {
        let resData = res.data;
        resData.map(item => {
          let arr1 = [];
          let arr2 = [];
          if (item.ApprovalMemberType === 0) {
            item.ApprovalMemberList.map(cItem => {
              arr1.push(cItem);
              arr2.push(cItem.UserID);
              return cItem;
            })
          }
          this.$set(item, 'AppMemberIds', arr2);
          this.$set(item, 'AppMemberData', arr1);
          this.$set(item, 'CCMemberIds', []);
          this.$set(item, 'CCMemberData', []);
          return item;
        })
        this.approvalData = resData;
        console.log(resData)
      }
    },
    delUser (res, isApproval, index) {
      let nodes = this.approvalData[index];
      if (isApproval) {//审批人
        for (let m = 0; m < nodes.AppMemberData.length; m++) {
          if (nodes.AppMemberData[m].UserID === res.UserID) {
            // nodes.ApprovalMember.push(nodes.AppMemberData[m]);
            nodes.AppMemberData.splice(m, 1);
            return false;
          }
        }
      } else {//抄送
        for (let m = 0; m < nodes.CCMemberData.length; m++) {
          if (nodes.CCMemberData[m].UserID === res.UserID) {
            nodes.CcMemberList.push(nodes.CCMemberData[m]);
            nodes.CCMemberData.splice(m, 1);
            return false;
          }
        }
      }
    },
    addUserFun (res, isApproval) {//添加
      if (isApproval) {//审批人
        this.addUserData = res;
        this.addUser = true;
      } else {//抄送
        this.addCCUserData = res;
        this.addCCUser = true;
      }
    },
    //添加审批人
    addAMUserFun (res) {
      this.addUserData.AppMemberData = [res];
      // let index =this.addUserData.ApprovalMember.map((item)=>{return item.UserID}).indexOf(res.UserID);
      // this.addUserData.ApprovalMember.splice(index, 1);
      this.addUser = false;
    },
    //添加抄送人
    addCCuserFun (res) {
      this.addCCUserData.CCMemberData.push(res);
      let index = this.addCCUserData.CcMemberList.map((item) => { return item.UserID }).indexOf(res.UserID);
      this.addCCUserData.CcMemberList.splice(index, 1);
      this.addCCUser = false;
    },
    showMoreFun (res) {//更多
      this.moreData = res;
      this.showMore = true;
    },
    //获取班级节次数据
    classSectionClick () {
      if (this.courseDate !== '') {
        this.getSubsitute();
      } else {
        this.xy.msgError('请先选择上课日期');
      }
    },
    async getSubsitute () {
      this.xy.loading();
      let res = await xyapi.get(`${this.$store.state.apiPath}/api/ClassTableGenerateForTeacherSubstituteApply/MobileTeacherTimeTable`,
        {
          startDate: new Date(this.courseDate).getTime()
        }
      );
      this.xy.unloading();
      if (res.success) {
        this.isShowClassSection = true;
        let resData = res.data;
        if (resData.length > 0) {
          this.district = [];
          for (res of resData) {
            this.district.push({
              id: res.ClassTableGenerateBaseID,
              label: res.OrgName + res.TimeName + res.SubjectName,
              showName: res.TimeName + res.SubjectName,
            });
          }

        } else {
          this.selectSessionId = 0;
        }
      }
    },
    cellSelect (val) {
      this.classSection = val.showName;
      this.classSectionID = val.id;
      this.subTeacher = '';
      this.subTeacherID = 0;
      this.isShowClassSection = false;
    },
    //代课教师
    teacherClick () {
      if (this.classSectionID > 0) {
        this.getTeachersByBase(1, true);
      } else {
        this.xy.msgError('请先选择班级节次');
        return false;
      }
    },
    async getTeachersByBase (type, isAgain) {
      this.xy.loading();
      let res = await xyapi.get(`${this.$store.state.apiPath}/api/ClassTableGenerateForTeacherSubstituteApply/GetTeachersByBase`,
        {
          classTableGenerateBaseID: this.classSectionID,
          searchType: type
        }
      );
      this.xy.unloading();
      if (res.success) {
        let resData = res.data;
        if (type === 1) {//1: 同年级同学科
          this.teacherData = [];
          for (var i = 0; i < resData.length; i++) {
            if (!resData[i].IsConflict) {
              this.teacherData.push(resData[i])
            }
          }
        }
        if (type === 4) {//4: 不同年级不同学科
          this.teacherAllData = [];
          for (let i = 0; i < resData.length; i++) {
            if (!resData[i].IsConflict) {
              this.teacherAllData.push(resData[i])
            }
          }
        }
        this.showTeacher = true;
        if (isAgain) {
          this.getTeachersByBase(4);
        }
      }
    },
    teacherSelect (ret) {
      this.subTeacher = ret.TeacherName;
      this.subTeacherID = ret.TeacherID;
      this.showTeacher = false;
    },
    checkNodeData () {
      let status = true
      this.approvalData.map(item => {
        if (item.NodeType === 1 && item.CCMemberData.length === 0) { //抄送
          status = false
          this.xy.msgError('请给抄送节点添加人员');
          return false
        } else { //审批
          if (item.ApprovalMemberType !== 0 && item.AppMemberData.length === 0) {
            status = false
            this.xy.msgError('请给审批节点添加人员');
            return false
          }
        }
      })
      return status
    },
    //保存
    async submitFlow () {
      if (this.classSectionID === 0) {
        this.xy.msgError('班级节次不能为空');
        return false;
      }
      if (this.subTeacherID.length > 0) {
        this.xy.msgError('代课教师不能为空');
        return false;
      }
      if (!this.checkNodeData()) {
        return false;
      }
      this.approvalData.map((item) => {
        let arr1 = [];
        let arr2 = [];
        item.AppMemberData.map((cItem) => {
          arr1.push(cItem.UserID);
          return cItem;
        })
        item.CCMemberData.map((ccItem) => {
          arr2.push(ccItem.UserID);
          return ccItem;
        })
        this.$set(item, 'AppMemberIds', arr1);
        this.$set(item, 'CCMemberIds', arr2);
        return item;
      })
      let arr = []
      this.approvalData.map(item => {
        arr.push({
          "WorkFlowNodeName": item.WorkFlowNodeName || '',
          "WorkFlowNodeID": 0,
          "ApprovalMemberRoleID": item.ApprovalMemberRoleID,
          "ApprovalMemberType": item.ApprovalMemberType,
          "ApprovalMode": item.ApprovalMode,
          "IsApprovalMySelf": item.IsApprovalMySelf,
          "IsApprovalComplete": item.IsApprovalComplete,
          "AppMembers": item.AppMemberIds,
          "CCMembers": item.CCMemberIds,
          "NodeType":item.NodeType
        })
      })
      this.xy.loading();
      let res = await xyapi.post(`${this.$store.state.apiPath}/api/ClassTableGenerateForTeacherApplyExamine/MobileSaveSub`,
        {
          ClassTableGenerateBaseID: this.classSectionID,
          TeacherID: this.subTeacherID,
          Description: this.option,
          WorkFlowNodes: arr
        }
      );
      this.xy.unloading();
      if (res.success) {
        this.xy.msgSuc('申请代课成功')
        this.back();
      }
    },
    //关闭
    back () {
      this.$router.push({ path: "/home/substituteTable" });
    }
  }
};
</script>
<style lang='less' >
.class-section {
  .van-cell__value--alone {
    text-align: center;
  }
}
.fotter-content {
  height: 110px;
  line-height: 110px;
  background: #fff;
  text-align: center;
  position: fixed;
  width: 100%;
  bottom: 0;
  .sub-fix-btn {
    width: 500px;
    height: 82px;
    line-height: 82px;
    text-align: center;
    background: rgba(65, 150, 255, 1);
    border: 2px solid rgba(104, 146, 254, 1);
    border-radius: 41px;
  }
}
.approval-flow {
  padding: 30px 30px;
  background: #fff;
  font-size: 28px;
  margin-bottom: 110px;
  padding-bottom: 110px;
  margin-top: 20px;
  .flow-title {
    font-size: 28px;
    color: #666666;
    margin-bottom: 40px;
  }
  .flow-ul {
    margin-left: 10px;
    /*border-left: 1px solid #e4e5e9;*/
  }
  .flow-li {
    padding-left: 32px;
    position: relative;
    border-left: 1px solid #e4e5e9;
    display: block;
  }
  .flow-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    height: 140px;
    padding: 6px 0;
    border-bottom: 1px solid #eeeeee;
    position: relative;
  }
  .flow-li:last-child {
    .flow-info:last-child {
      border-bottom: none;
    }
  }
  .flow-info {
    .timeline-icon {
      width: 18px;
      height: 18px;
      border-radius: 99px;
      background-color: #e4e5e9;
      position: absolute;
      z-index: 1;
      left: -32px;
      display: block;
      top: 66px;
      -webkit-transform: translate(-50%);
      transform: translate(-50%);
    }
  }
  .user-ul {
    display: flex;
    justify-content: flex-end;
  }
  .user-li {
    margin: 0 10px;
    position: relative;
    width: 100px;
  }
  .user-li .user-del-icon {
    position: absolute;
    top: -6px;
    right: -8px;
    z-index: 1;
    font-size: 28px !important;
    color: #f87c7c;
  }
  .user-li {
    .user-name {
      width: 66px;
      height: 66px;
      line-height: 66px;
      text-align: center;
      background: rgba(65, 150, 255, 1);
      border-radius: 50%;
      color: #fff;
      font-size: 22px;
      position: relative;
      margin: 0 auto 10px;
    }
  }
  .user-li {
    .user-add {
      width: 66px;
      height: 66px;
      line-height: 66px;
      text-align: center;
      border: 1px dashed #4196ff;
      border-radius: 50%;
      color: #4196ff;
      font-size: 22px;
      margin: auto;
    }
  }
  .bottom-type {
    font-size: 24px;
    color: #666666;
    text-align: center;
  }
  .more-list {
    background: #fff;
    padding: 10px;
    border-radius: 8px;
    min-height: 50px;
    display: flex;
    justify-content: flex-start;
  }
}
</style>  

